/**
 * FeatureCard — single tile in the features grid.  Hover lifts via shadow.
 */
import React, { useState } from 'react';
import { COLOR, FONT, RADIUS, ELEVATION } from '../../../components/ss/tokens';

export default function FeatureCard({ icon, title, body, index = 0 }) {
  const [hover, setHover] = useState(false);
  return (
    <div
      data-reveal
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: '#fff',
        border: `1px solid ${hover ? COLOR.blueBorder : COLOR.grayBorder}`,
        borderRadius: RADIUS.lg,
        padding: 28,
        boxShadow: hover ? '0 18px 40px -18px rgba(13,27,46,.35)' : ELEVATION.xs,
        transform: hover ? 'translateY(-6px)' : 'none',
        transition: 'transform .28s cubic-bezier(.16,.84,.44,1), box-shadow .28s, border-color .28s',
        ['--d']: `${(index % 4) * 90}ms`,
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: RADIUS.md,
          background: COLOR.blueBg,
          color: COLOR.blue,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 26,
          marginBottom: 18,
          transform: hover ? 'scale(1.12) rotate(-4deg)' : 'none',
          transition: 'transform .28s cubic-bezier(.16,.84,.44,1)',
        }}
        aria-hidden
      >
        {icon}
      </div>
      <h3
        style={{
          margin: 0,
          fontSize: 18,
          fontWeight: FONT.weight.bold,
          color: COLOR.text,
          letterSpacing: '-0.2px',
        }}
      >
        {title}
      </h3>
      <p
        style={{
          marginTop: 10,
          marginBottom: 0,
          fontSize: FONT.size.md,
          lineHeight: 1.6,
          color: COLOR.textMuted,
        }}
      >
        {body}
      </p>
    </div>
  );
}
